import { useState } from "react";
import CustomButton from "../../components/CustomButton";
import { useTranslation } from "react-i18next";
import Modal from "../../components/Modal";
import classes from "../../components/Modal.module.css";
import ErrorMessage from "../../components/ErrorMessage";
import saveIcon from "../../assets/save_icon.png";
import CustomInput from "../../components/CustomInput";
import CustomInputWithUnit from "../../components/CustomInputWithUnit";
import { onlyNums } from "../../utils/OnlyNums";
import Textarea from "../../components/Textarea";
import ErrorBox from "../../components/ErrorBox";
import Loader, { LOADER_SIZES } from "../../components/Loader";
import closeIcon from "../../assets/close_icon.png"
import axiosClient from "../../services/axiosClient";


export default function AddEntitlementsModal({ onClose, onSuccess }) {
  const { t } = useTranslation("general");
  const [loadingModal, setLoadingModal] = useState(false);
  const [error, setError] = useState(null);
  const [validationError, setValidationError] = useState(null);
  const [entitlement, setEntitlement] = useState({
    name: "",
    price: 0,
    notes: "",
  });

  const handleCancel = () => {
    onClose();
  };

  const handleAddEntitlement = async () => {
    if (!entitlement.name.trim()) {
      setValidationError("noEntitlementName");
      return;
    }

    if (!entitlement.price || parseFloat(entitlement.price) <= 0) {
      setValidationError("invalidEntitlementValue");
      return;
    }

    try {
      setLoadingModal(true);
      setError(null);

      const response = await axiosClient.post("/entitlements/createEntitlement", entitlement);

      onSuccess();
      
    } catch (err) {
      console.error("Error creating entitlement:", err);
      setError("entitlementCreationFailed");
    } finally {
      setLoadingModal(false);
    }
  };

  return (
    <>
      <Modal
        title="addEntitlement"
        onClose={handleCancel}
        modalSize={"c-modal--small"}
        footer={
          <>
            {loadingModal ? <Loader size={LOADER_SIZES.MEDIUM} /> : null}
            {error ? (
              <ErrorMessage classList="o-row o-row--horizontal-align_end">
                {t(error)}
              </ErrorMessage>
            ) : null}
            {validationError ? (
              <ErrorMessage classList="o-row o-row--horizontal-align_end">
                {t(validationError)}
              </ErrorMessage>
            ) : null}
            <section className={classes.actions}>
              <CustomButton
                onClick={handleAddEntitlement}
                title={t("confirm")}
                icon={saveIcon}
                iconSize={16}
                disabled={loadingModal}
              />
              <CustomButton
                title={t("cancel")}
                onClick={handleCancel}
                variant="blank"
                icon={closeIcon}
                iconSize={16}
              />
            </section>
          </>
        }
      >
        {error ? (
          <ErrorBox classList="o-row o-row--horizontal-align_end">
            {t(error)}
          </ErrorBox>
        ) : null}
        {validationError ? (
          <ErrorBox classList="o-row o-row--horizontal-align_end">
            {t(validationError)}
          </ErrorBox>
        ) : null}
        <div className="o-column o-column--gap-size_400">
          <CustomInput
            title={t("entitlementName")}
            name="entitlementName"
            value={entitlement.name}
            onChange={(e) => {
              if (validationError === "noEntitlementName") {
                setValidationError(null);
              }
              setEntitlement((prev) => ({
                ...prev,
                name: e.target.value,
              }));
            }}
            flex={true}
            errorText={
              validationError === "noEntitlementName"
                ? t("noEntitlementName")
                : ""
            }
          />

          <CustomInputWithUnit
            name="price"
            title={t("price")}
            value={entitlement.price}
            onChange={(e) => {
              if (validationError === "invalidEntitlementValue") {
                setValidationError(null);
              }
              setEntitlement((prev) => ({
                ...prev,
                price: e.target.value,
              }));
            }}
            onKeyDown={onlyNums}
            flex={true}
            min={0}
            max={100}
            unit="IQD"
            type="moneyV2"
            errorText={
              validationError === "invalidEntitlementValue"
                ? t("invalidEntitlementValue")
                : ""
            }
          />

          <div className="">
            <label>{t("notes")}</label>
            <Textarea
              name="notes"
              value={entitlement.notes}
              onChange={(e) => {
                setEntitlement((prev) => ({
                  ...prev,
                  notes: e.target.value,
                }));
              }}
              flex={true}
            />
          </div>
        </div>
      </Modal>
    </>
  );
}
